import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { CountryService } from '../../services/country.service';
import { ProgramService } from '../../services/program.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { DropdownService } from '../../services/dropdown.service';
import { CourseService } from '../../services/course.service';

@Component({
  selector: 'app-course-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, SelectInputComponent],
  templateUrl: './course-page.component.html',
  styleUrl: './course-page.component.css'
})
export class CoursePageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;

  page_name = 'Course';
  form: FormGroup;
  params: any = {};
  selected_program_ids: any = {}
  items: any[] = [];

  country_cols: any = [
   { headerName: 'Sr.No', field: 'SrNo',flex:1 },
    { field: 'university.name', headerName: 'School', filter: true, flex: 1, },
    { field: 'stream.name', headerName: 'Stream Name', filter: true, flex: 1, },
    { field: 'program.name', headerName: 'Program Name', filter: true, flex: 1, },
    { field: 'name', headerName: 'Course Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Course Code', filter: true, flex: 1, },
    { field: 'owner', headerName: 'Course Owner ', filter: true, flex: 1, },
    { field: 'credits', headerName: 'Course Credits ', filter: true, flex: 1, },
    { field: 'email', headerName: 'Course Email', filter: true, flex: 1, },
    { field: 'contact', headerName: 'Course contact', filter: true, flex: 1, },
    { headerName: "Actions", sortable: false, flex: 1, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', }
  ];
  bulk_columns = [
    { column_name: 'University Name', type: 'text', return_as: 'university_id', sample_value: 'UG' },
    { column_name: 'Program Name', type: 'text', return_as: 'name', sample_value: 'UG' },
    { column_name: 'Program Code', type: 'text', return_as: 'code', sample_value: 'UG' },
    { column_name: 'Program Owner', type: 'text', return_as: 'program_owner', sample_value: 'XYZ' },
    { column_name: 'Program Email', type: 'text', return_as: 'owner_email', sample_value: 'program@gmail.com', strict_validation: 'email' },
    { column_name: 'Program Contact', type: 'text', return_as: 'owner_contact', sample_value: '987643219', strict_validation: 'mobile' },

  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this) })
    actions.push({ text: 'Update', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', function: this.open_form_modal.bind(this) })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this) })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public cs: CourseService, public ar: ActivatedRoute, public ds: DropdownService) {
    this.form = this.fb.group({
      name: ['', [Validators.pattern("^[A-Za-z ]*$"), Validators.required]],
      code: ['', [Validators.required, Validators.pattern("^[A-Za-z ]*$")]],
      university_id: ['', [Validators.required]],
      program_id: ['', [Validators.required]],
      stream_id: ['', [Validators.required]],
      owner: ['', [Validators.pattern("^[A-Za-z ]*$")]],
      email: ['', [Validators.email]],
      contact: ['', [Validators.pattern("^[0-9]*$")]],
      credits: ['', [Validators.pattern("^[0-9]*$")]],
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['program', 'stream', 'university']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
    })
  }
  async get_list(filter?: any) {
    try {
     const res = await this.cs.get_list(filter);
      const page = filter?.page || 1;
      const pagesize = filter?.page_size || 10;
      const startindex = (page - 1) * pagesize;

      res.data = res.data.map((item: any, index: number) => ({
        ...item,
        SrNo: startindex + index + 1
      }));

      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }
  async delete(item: any, index: any) {
    this.selected_program_ids = item;
    this.confirmation_delete_modal?.open();
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_program_ids = item || {};
    this.view_modal?.open();
  }
  async delete_program() {
    let res = await this.cs.delete(this.selected_program_ids.id);
    this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    this.selected_program_ids = {};
    this.confirmation_delete_modal?.close()
    this.ds.invalidate_dropdown_cache('course');
    await this.get_list(this.params);
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      let res = await this.cs.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.ds.invalidate_dropdown_cache('course');
    await this.get_list(this.params);
  }
  async open_form_modal(item?: any) {
    this.selected_program_ids = item || {};
    if (this.selected_program_ids && this.selected_program_ids.id) {
      let response = await this.cs.get(item.id);
      this.selected_program_ids = { ...response.data };
      this.form.patchValue({ ...this.selected_program_ids, });
    } else {
      this.selected_program_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit_program() {
    if (this.form.invalid) {
      this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
      this.form.markAllAsTouched();
      return;
    }
    let form_value = this.form.value;
    if (this.selected_program_ids && this.selected_program_ids.id) {
      let update_response = await this.cs.update(this.selected_program_ids.id, form_value);
      this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
    } else {
      let create_response = await this.cs.add(form_value);
      this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
    }
    this.ds.invalidate_dropdown_cache('course');
    await this.get_list(this.params);
    this.close_form_modal();
  }
  async bulk_upload(data: any, spinner: any) {
    try {
      await this.gs.bulk_form_submission(data, this.cs, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      console.error(error?.error?.message, '');
    }
  }
}
